export default "__VITE_ASSET__BFHcdPDH__"